import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { CloseOutlined, DeleteOutline } from "@mui/icons-material";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import DispatcherApi from "Services/Dispatcher";

const ServiceDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [profileimage, setprofileimage] = useState(null);
  const [username, setusername] = useState(null);

  const getDetails = useCallback(() => {
    if (!id) return;
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setprofileimage(res?.data?.data?.image);
        setusername(res?.data?.data?.firstName);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    DispatcherApi.getDispatcherDetails(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  useEffect(() => {
    if (openDialog) {
      getDetails();
    }
  }, [openDialog, getDetails]);

  const handleDeleteServicetype = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Dispatcher Deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while deleting dispatcher",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    DispatcherApi.deleteDispatcher(id).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      {/* Header */}
      <Box className={classes.dialogHeader}>
        <Typography className={classes.dialogHeaderTitle}>Delete Dispatcher</Typography>
        <IconButton className={classes.closeIconBtn} onClick={handleClose}>
          <CloseOutlined />
        </IconButton>
      </Box>

      {/* Body */}
      <Box className={classes.dialogBody}>
        <Box className={classes.avatarWrapper}>
          <img
            src={profileimage || "/assets/images/user/avatar.png"}
            alt="Dispatcher"
            className={classes.avatarImg}
          />
          <Typography className={classes.nameText}>{username || "This dispatcher"}</Typography>
        </Box>
        <Typography className={classes.descriptionText}>
          Are you sure you want to delete <strong>{username || "this dispatcher"}</strong>? This action cannot be undone.
        </Typography>
      </Box>

      {/* Footer */}
      <Box className={classes.dialogFooter}>
        <Button className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={classes.deleteButton}
          onClick={handleDeleteServicetype}
          startIcon={<DeleteOutline />}
        >
          Delete Dispatcher
        </Button>
      </Box>
    </Dialog>
  );
};

export default ServiceDelete;
